import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class CoreService {
	loadImage(defaultImage: string, finalImage?: string | null): Observable<string> {
		return new Observable(subscriber => {
			subscriber.next(defaultImage);

			if (!finalImage || finalImage === defaultImage) {
				subscriber.complete();
				return;
			}

			const image = new Image();
			image.onload = (): void => {
				subscriber.next(finalImage);
				subscriber.complete();
			};
			image.onerror = (): void => subscriber.complete();
			image.src = finalImage;

			return () => {
				image.onload = null;
				image.onerror = null;
			};
		});
	}
}